/**
 * 路由守卫配置
 * 用于保护需要登录的页面
 */

import { isUserLoggedIn } from '@/utils/request'

/**
 * 设置认证守卫（简化版本，主要逻辑已移至路由配置中）
 * @param {Object} router Vue Router实例
 */
export function setupAuthGuards(router) {
  // 这里可以添加一些全局的路由处理逻辑
  
  // 全局错误处理
  router.onError((error) => {
    console.error('路由错误:', error)
  })
  
  console.log('认证守卫已设置')
}

/**
 * 检查特定路由是否需要登录
 * @param {string} path 路由路径
 * @returns {boolean} 是否需要登录
 */
export function routeRequiresAuth(path) {
  const authRequiredRoutes = [
    '/digiKey',
    '/favorite', 
    '/history',
    '/batchSearch'
  ]
  return authRequiredRoutes.some(route => path.startsWith(route))
}

/**
 * 检查特定路由是否为公共路由
 * @param {string} path 路由路径  
 * @returns {boolean} 是否为公共路由
 */
export function isPublicRoute(path) {
  const publicRoutes = [
    '/login',
    '/register',
    '/forgot-password'
  ]
  return publicRoutes.some(route => path.startsWith(route))
}

/**
 * 检查用户权限
 * @param {Object} user 用户信息
 * @param {string} requiredRole 需要的角色
 * @returns {boolean} 是否有权限
 */
export function hasPermission(user, requiredRole) {
  if (!user || !user.role) {
    return false
  }
  
  // 角色权限层级：admin > user > guest
  const roleHierarchy = {
    'admin': 3,
    'user': 2, 
    'guest': 1
  }
  
  const userLevel = roleHierarchy[user.role] || 0
  const requiredLevel = roleHierarchy[requiredRole] || 0
  
  return userLevel >= requiredLevel
}

/**
 * 获取用户角色显示文本
 * @param {string} role 角色代码
 * @returns {string} 角色显示文本
 */
export function getRoleDisplayName(role) {
  const roleMap = {
    'admin': '管理员',
    'user': '普通用户',
    'guest': '访客'
  }
  return roleMap[role] || '未知角色'
}

export default {
  setupAuthGuards,
  routeRequiresAuth,
  isPublicRoute,
  hasPermission,
  getRoleDisplayName
} 